export default __webpack_public_path__ + "static/media/rocket.382f3822.png";